export default {
    type: 0,
    code:'',
    token: '',
    // token: 'wx-4mWwPbQgy6DCpwh1x0QWLQ==',
    setType(type){
        this.type = type;
    },
    showDialog: true,
    setShowDialog(show){
        this.setShowDialog = show;
    },
    navtab: 0,
    selectIndex: 0,
    admainTab: 0,
    admainIndex: 0,
    itemIndex: 0,
    userInfo:{
        userName: '',
        userLogo: '',
        userStore: '',
        userCity: '',
        userId: ''
    },
    isLogin: false
}


// WEBPACK FOOTER //
// ./src/store/index.js